import styled from 'styled-components';

export const CustomTableLayout = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${(props: any) => props.theme.zindex.small};
  display: flex;
  background-color: ${(props: any) => props.theme.colors.light};
  flex-direction: column;
`;

export const CustomTableMain = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const CustomTableContent = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const CustomTableSelectionPanel = styled.div`
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow: hidden;
`;

export const CustomTableCatalogPanel = styled.div`
  box-sizing: border-box;
  padding-bottom: 8px;
  min-width: 500px;
  width: 48%;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  background-color: ${(props: any) => props.theme.colors.light_dark};
  position: relative;
`;

export const CustomTableItemsScrollArea = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: ${(props: any) => props.theme.spacing.large};
  overflow: auto;
  button.button-smaller {
    padding: ${(props: any) => props.theme.spacing.xsmall}
      ${(props: any) => props.theme.spacing.small};
    font-size: ${(props: any) => props.theme.size.small};
    height: auto;

    i svg {
      width: ${(props: any) => props.theme.size.small};
      height: ${(props: any) => props.theme.size.small};
    }
  }
`;

export const CustomTableTaxonomyContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  min-height: 0;
  overflow: hidden;

  & > * {
    box-sizing: border-box;
    flex: 1;
    min-height: 0;
  }

  & [data-test='result-container'] {
    height: 100%;
  }
`;
